/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S7_R3_BodyInputs */

const tr_iletisim_s7_r3_body = /** @type {(inputs: Iletisim_S7_R3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online şikayet kaydı ve başvuru takibi için resmi portal.`)
};

const en_iletisim_s7_r3_body = /** @type {(inputs: Iletisim_S7_R3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official portal for filing complaints online and tracking applications.`)
};

const de_iletisim_s7_r3_body = /** @type {(inputs: Iletisim_S7_R3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offizielles Portal für die Online-Erfassung von Beschwerden und die Verfolgung von Anträgen.`)
};

const ru_iletisim_s7_r3_body = /** @type {(inputs: Iletisim_S7_R3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Официальный портал для онлайн-регистрации жалоб и отслеживания обращений.`)
};

/**
* | output |
* | --- |
* | "Official portal for filing complaints online and tracking applications." |
*
* @param {Iletisim_S7_R3_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s7_r3_body = /** @type {((inputs?: Iletisim_S7_R3_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S7_R3_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s7_r3_body(inputs)
	if (locale === "de") return de_iletisim_s7_r3_body(inputs)
	if (locale === "ru") return ru_iletisim_s7_r3_body(inputs)
	return tr_iletisim_s7_r3_body(inputs)
});